// extracted by mini-css-extract-plugin
export default {"rating":"NR-z","numberOfStars":"OR-z","count":"PR-z","barGraphSpacing":"QR-z","barGraph":"RR-z"};